import { LOQATE_API_KEY } from '../env/server';
import config from '../config';

const loqate = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * API Key for the Loqate integration.
       *
       * Usually goes in the `Key` field in the payload or query parameters.
       */
      apiKey: LOQATE_API_KEY,

      /**
       * Base URL for the Loqate integration.
       */
      baseUrl: 'https://api.addressy.com'
    }
  }
});

export default loqate;
